/**
 * OrderConfirmedPresenter
 * --
 */
import React from 'react';

const OrderConfirmedPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p>OrderConfirmedPresenter</p>
    </div>
  );
};

export default OrderConfirmedPresenter;
